import type { ClienteItem, FiltroClientes } from "../../../services/clientesFornecedor"

export type { ClienteItem, FiltroClientes }

export const FiltroInicial: FiltroClientes = {
    nome: "",
    email: "",
    telefone: "",
    cidade: "",
    bairro: "",
    spam: "",
    diasAusenciaInicio: "",
    diasAusenciaFinal: "",
    dataInicioCadastro: "",
    dataFimCadastro: "",
    dataInicioNascimento: "",
    dataFimNascimento: "",
    idadeInicio: "",
    idadeFinal: "",
    sexo: "",
    apenasNaoNotificadsoDias: "",
}

export interface ClientesFornecedorState {
    clientes: ClienteItem[]
    total: number
    pagina: number
    tamanhoPagina: number
    filtro: FiltroClientes
}

export const TAMANHO_PAGINA = 25

export const ClientesFornecedorInicial: ClientesFornecedorState = {
    clientes: [],
    total: 0,
    pagina: 0,
    tamanhoPagina: TAMANHO_PAGINA,
    filtro: FiltroInicial,
}
